import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CircularSlider } from 'react-web-circular-slider';

import { CardWithHeaderActions } from '../../components/layout/CardContent';
import { ButtonClearSchedules } from '../../components/ButtonClearSchedules';
import { ButtonText } from '../../components/Buttons';

import { GetThemeColour } from '../../utils/ThemeHelper';

import { Settings } from '../../utils/Settings';

import { DayOptions } from './components/DayOptions';
import ItemCrudContext from '../../dataAccess/ItemCrudContext';
import { NotificationAlert } from '../../components/GeneralError';
import { ErrorAlert } from '../../components/GeneralError';

import dayjs from 'dayjs';
import Loading from '../../components/Loading';

const startTimeDefault = '22:00';
const endTimeDefault = '08:00';
const daysActiveDefault = [true, true, true, true, true, false, false];

const StartIcon = (
	<g transform="translate(-11, -8)">
		<path d="M 4.195 1.153 L 1.942 0.056 C 1.662 -0.052 1.326 0.028 1.188 0.308 C 1.046 0.586 1.155 0.923 1.439 1.062 L 3.692 2.157 C 3.771 2.195 3.856 2.217 3.944 2.217 C 4.203 2.217 4.432 2.037 4.495 1.782 C 4.554 1.531 4.43 1.265 4.195 1.153 Z M 3.944 10.074 C 3.856 10.074 3.771 10.099 3.693 10.137 L 1.44 11.233 C 1.157 11.367 1.047 11.707 1.185 11.983 C 1.327 12.234 1.662 12.374 1.942 12.241 L 4.195 11.145 C 4.429 11.025 4.552 10.761 4.495 10.542 C 4.434 10.286 4.203 10.074 3.944 10.074 Z M 18.593 2.217 C 18.681 2.217 18.764 2.197 18.843 2.157 L 21.098 1.062 C 21.379 0.923 21.489 0.586 21.348 0.308 C 21.212 0.057 20.873 -0.083 20.596 0.057 L 18.343 1.153 C 18.109 1.265 17.986 1.531 18.043 1.782 C 18.105 2.037 18.332 2.217 18.593 2.217 Z M 3.381 6.132 C 3.381 5.849 3.13 5.567 2.817 5.567 L 0.563 5.567 C 0.251 5.567 0 5.817 0 6.099 C 0 6.38 0.251 6.695 0.563 6.695 L 2.817 6.695 C 3.13 6.695 3.381 6.477 3.381 6.132 Z M 21.972 5.567 L 19.718 5.567 C 19.407 5.567 19.156 5.817 19.156 6.099 C 19.156 6.38 19.407 6.631 19.718 6.631 L 21.972 6.631 C 22.287 6.631 22.538 6.38 22.538 6.099 C 22.538 5.817 22.288 5.567 21.972 5.567 Z M 21.098 11.293 L 18.843 10.197 C 18.566 10.088 18.226 10.173 18.087 10.449 C 17.949 10.725 18.059 11.064 18.341 11.205 L 20.595 12.301 C 20.873 12.439 21.212 12.327 21.352 12.046 C 21.492 11.767 21.379 11.431 21.098 11.293 Z M 11.252 -0.035 C 7.842 -0.024 5.071 2.777 5.071 6.211 C 5.071 7.723 5.616 9.183 6.604 10.318 C 7.074 10.857 7.867 12.064 8.144 12.995 C 8.181 13.301 8.456 13.508 8.766 13.477 C 9.073 13.444 9.294 13.162 9.262 12.856 L 9.241 12.739 C 8.879 11.508 7.974 10.174 7.453 9.579 C 6.646 8.645 6.198 7.451 6.198 6.211 C 6.198 3.35 8.416 1.101 11.252 1.096 L 11.269 1.096 C 12.61 1.096 13.877 1.619 14.833 2.572 C 15.805 3.54 16.34 4.83 16.34 6.211 C 16.34 7.451 15.894 8.646 15.084 9.58 C 14.566 10.174 13.658 11.509 13.297 12.739 L 13.274 12.858 C 13.237 13.166 13.448 13.477 13.757 13.517 C 13.781 13.519 13.81 13.522 13.835 13.522 C 14.112 13.522 14.341 13.342 14.377 13.059 C 14.671 12.064 15.464 10.857 15.934 10.318 C 16.922 9.181 17.467 7.723 17.467 6.211 C 17.467 4.533 16.813 2.954 15.628 1.772 C 14.456 0.599 12.875 -0.076 11.252 -0.035 Z M 13.491 14.582 L 9.016 14.582 C 8.703 14.582 8.451 14.834 8.451 15.147 L 8.454 15.934 C 8.454 16.154 8.52 16.372 8.644 16.556 L 9.243 17.461 C 9.43 17.737 9.852 17.964 10.182 17.964 L 12.356 17.964 C 12.689 17.964 13.111 17.737 13.293 17.462 L 13.896 16.556 C 13.999 16.4 14.084 16.12 14.084 15.934 L 14.084 15.147 C 14.054 14.869 13.832 14.582 13.491 14.582 Z M 12.955 15.967 L 12.389 16.828 C 12.371 16.844 12.33 16.866 12.357 16.867 L 10.234 16.872 C 10.22 16.867 10.194 16.862 10.184 16.862 C 10.179 16.862 10.179 16.852 10.184 16.862 L 9.582 15.965 L 9.582 15.739 L 12.961 15.739 L 12.961 15.921 C 12.955 15.937 12.949 15.967 12.955 15.967 C 12.955 15.967 12.951 15.97 12.955 15.967 Z M 11.832 2.784 C 11.832 2.471 11.58 2.219 11.269 2.219 C 9.094 2.219 7.324 3.988 7.324 6.132 C 7.324 6.444 7.576 6.695 7.888 6.695 C 8.199 6.695 8.451 6.443 8.451 6.132 C 8.451 4.578 9.714 3.347 11.269 3.347 C 11.579 3.347 11.832 3.094 11.832 2.784 Z" />
	</g>
);

const StopIcon = (
	<g transform="translate(-6, -9)">
		<path d="M 8.434 14.562 L 3.94 14.562 C 3.629 14.562 3.379 14.814 3.38 15.126 L 3.378 15.94 C 3.379 16.16 3.442 16.379 3.564 16.562 L 4.166 17.466 C 4.35 17.742 4.772 17.968 5.103 17.968 L 7.272 17.968 C 7.603 17.968 8.024 17.742 8.207 17.466 L 8.807 16.563 C 8.912 16.407 8.995 16.128 8.996 15.94 L 8.993 15.155 C 8.992 14.847 8.744 14.562 8.434 14.562 Z M 7.872 15.944 L 7.305 16.803 C 7.288 16.819 7.245 16.841 7.275 16.842 L 5.156 16.847 C 5.14 16.843 5.115 16.838 5.104 16.838 C 5.1 16.838 5.1 16.829 5.104 16.838 L 4.504 15.941 L 4.504 15.718 L 7.876 15.718 L 7.876 15.9 C 7.872 15.917 7.864 15.944 7.872 15.944 C 7.872 15.944 7.869 15.947 7.872 15.944 Z M 10.539 1.772 C 9.368 0.605 7.79 -0.072 6.17 -0.03 C 2.766 -0.021 0 2.778 0 6.205 C 0 7.714 0.544 9.171 1.532 10.305 C 2 10.843 2.792 12.048 3.069 12.977 C 3.105 13.283 3.379 13.492 3.688 13.459 C 3.995 13.426 4.215 13.145 4.184 12.84 L 4.164 12.722 C 3.801 11.494 2.897 10.162 2.38 9.567 C 1.57 8.634 1.125 7.444 1.125 6.205 C 1.125 3.349 3.341 1.105 6.17 1.097 L 6.188 1.097 C 7.528 1.097 8.791 1.62 9.745 2.571 C 10.717 3.538 11.25 4.827 11.25 6.205 C 11.25 7.443 10.805 8.636 9.996 9.567 C 9.477 10.163 8.575 11.494 8.212 12.723 L 8.19 12.841 C 8.153 13.148 8.363 13.458 8.67 13.498 C 8.698 13.501 8.724 13.503 8.751 13.503 C 9.025 13.503 9.256 13.323 9.291 13.042 C 9.584 12.049 10.376 10.844 10.844 10.306 C 11.83 9.17 12.374 7.714 12.374 6.205 C 12.374 4.53 11.724 2.953 10.539 1.772 Z M 6.75 2.782 C 6.75 2.471 6.499 2.22 6.188 2.22 C 4.017 2.22 2.25 3.986 2.25 6.126 C 2.25 6.466 2.502 6.72 2.812 6.72 C 3.123 6.72 3.375 6.468 3.375 6.157 C 3.375 4.606 4.636 3.376 6.188 3.376 C 6.497 3.343 6.75 3.092 6.75 2.782 Z" />
	</g>
);

const formatTime = ({ h, m }, format = 'HH:mm') => {
	return dayjs().hour(h).minute(m).format(format);
};

const isIsoDateTime = (value) => {
	const isoDatePattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})Z$/;
	const isValidIsoDate = isoDatePattern.test(value);
	if (isValidIsoDate) return true;

	const d = new Date(value);
	return d instanceof Date && !isNaN(d) && d.toISOString() === value; // valid date
};

const formatDateTime = (value, format = 'HH:mm') => {
	if (!isIsoDateTime(value)) return value;
	return Settings.formatDate(value, 'custom', format);
};

const HeaderActions = ({ onReset, chargePointId }) => {
	return (
		<div className="d-flex align-items-end">
			<ButtonClearSchedules isOnline={false} onReset={onReset} chargePointId={chargePointId} />
		</div>
	);
};

export const ChargeSchedule = (props) => {
	const { t } = useTranslation();
	const containerRef = useRef();
	const { recId = null } = props.chargePoint ?? [{}];

	const { data, getData, onChange, updateObject, resetItem } = ItemCrudContext(`/chargePoint/${recId}/schedule`, null, {
		connectorId: 0,
		startTime: startTimeDefault,
		endTime: endTimeDefault,
		duration: '',
		daysActive: [...daysActiveDefault],
	});
	const { item, isBusy = true, isDirty, hasError, wasSaved } = data;

	//TODO: Add this into the theme so that it can be defaulted by the backend
	let { startTime = startTimeDefault, endTime = endTimeDefault, daysActive = [...daysActiveDefault] } = item;
	const startingTime = formatDateTime(startTime);
	const endingTime = formatDateTime(endTime);

	const [duration, setDuration] = useState(0);

	const setStartTime = async ({ startTime, durationMinutes }) => {
		if (!startTime || !durationMinutes || isNaN(durationMinutes)) return;

		const start = formatTime(startTime);
		await onChange({ currentTarget: { name: 'startTime', value: start } });
		setDuration(durationMinutes);
	};

	const setEndTime = async ({ endTime, durationMinutes }) => {
		if (!endTime || !durationMinutes || isNaN(durationMinutes)) return;

		const end = formatTime(endTime);
		await onChange({ currentTarget: { name: 'endTime', value: end } });
		setDuration(durationMinutes);
	};

	const onSet = async () => {
		const startArray = startingTime.split(':') || ['00'];
		const endArray = endingTime.split(':') || ['00'];
		const start = Settings.formatTimeToUtc(startArray[0], startArray[1]);
		const end = Settings.formatTimeToUtc(endArray[0], endArray[1]);

		updateObject({ ...item, startTime: start, endTime: end });
	};

	let radius = (containerRef.current?.clientWidth - 10) / 2 ?? 180;
	if (radius > 180) radius = 180;

	useEffect(() => {
		getData();
	}, []);

	return (
		<CardWithHeaderActions heading={t('sc.scheduleCharging')} actions={<HeaderActions onReset={resetItem} chargePointId={recId} />}>
			{hasError && <ErrorAlert message={hasError} />}
			{wasSaved && <NotificationAlert message={t('sc.savedSuccessfully')} />}
			{isBusy ? (
				<Loading message={t('sc.loadingSchedule')} />
			) : (
				<>
					<div className="d-flex flex-column align-items-center w-100 h-100" ref={containerRef} style={{ position: 'relative' }}>
						<CircularSlider
							bgCircleColor="#ffffff"
							gradientColorFrom={GetThemeColour('--primary')}
							gradientColorTo={GetThemeColour('--primary')}
							strokeWidth={30}
							initialStartTime={startingTime}
							initialEndTime={endingTime}
							onStartUpdate={setStartTime}
							onEndUpdate={setEndTime}
							startIcon={StartIcon}
							stopIcon={StopIcon}
							radius={radius}
						/>

						<div className="d-flex flex-column text-center" style={{ position: 'absolute', top: '30%', left: 'auto' }}>
							<label className="m-0">
								<b>{t('sc.start')}</b>
								<span className="mr-3 ml-3">&nbsp;</span>
								<b>{t('sc.end')}</b>
							</label>
							<label className="m-0">{`${startingTime} - ${endingTime}`}</label>

							<div className="d-flex flex-column mt-2">
								<h2 className="text-gray-600 m-0">{t('sc.duration')}</h2>
								<h2 className="text-gray-600 m-0">{Settings.formatDuration(duration, 'minutes', 'HH[h] mm[m]')}</h2>
							</div>
						</div>

						<DayOptions title={t('sc.daysActive')} daysActive={daysActive} onChange={onChange} />
					</div>

					<div className="row justify-content-end mr-1">
						<ButtonText text={t('sc.set')} icon="fa-save" isBusy={isBusy} disabled={!isDirty} onClick={onSet} />
					</div>
				</>
			)}
		</CardWithHeaderActions>
	);
};
